<div class="loader-overlay" *ngIf="show">
  <!-- <div class="loader"></div>
  <p class="loader-text">Loading...</p> -->
  <div class="loader-container">
  <div class="loader-content">
    
    <!-- Animated Balloon -->
    <div class="balloon-wrapper">
      <div class="balloon animate-bounce">
        <div class="balloon-body">
          <div class="shine"></div>
          <div class="heart">
            <svg viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd"></path>
            </svg>
          </div>
        </div>
        <div class="balloon-string"></div>
        <div class="balloon-knot"></div>
      </div>

      <!-- Floating particles -->
      <div class="particle particle1"></div>
      <div class="particle particle2"></div>
    </div>

    <!-- Brand -->
    <div class="brand">
      <h1>Clocc That Tea</h1>
      <p>Dating</p>
    </div>

    <!-- Progress Bar -->
    <div class="progress-wrapper">
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="progress">
          <div class="progress-pulse"></div>
        </div>
      </div>
      <div class="loading-text">
        <span>Find your match</span>
        <span class="dot dot1">.</span>
        <span class="dot dot2">.</span>
        <span class="dot dot3">.</span>
      </div>
    </div>

  </div>
</div>

</div>
